export const getAuthenticationConfig = () => ({
  TOKEN_STORAGE_KEY: 'auth_refresh_token',
  REFRESH_TOKEN_INTERVAL: 300, /* 5 minutes = 300 seconds */
});
